<kui-modal
    #modal
    [title]="'Theme Settings JSON'"
    [actions]="modalActions"
    (onClose)="closeModal()"
>
    <div class="p-4">
        <div class="pb-4">
            Below is the raw settings JSON for the theme. You can copy this to another theme or paste settings from another theme here.
        </div>
        <textarea class='w-100 font-monospace' style='height: 380px; white-space: nowrap;  overflow: auto' [(ngModel)]="json"></textarea>

        <div class="pt-3 text-danger" *ngIf='errorMessage'>
            {{ errorMessage}}
        </div>
    </div>
</kui-modal>